/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoredFile
 */
export interface StoredFile {
    /**
     * 
     * @type {string}
     * @memberof StoredFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StoredFile
     */
    name: string;
}

/**
 * Check if a given object implements the StoredFile interface.
 */
export function instanceOfStoredFile(value: object): value is StoredFile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function StoredFileFromJSON(json: any): StoredFile {
    return StoredFileFromJSONTyped(json, false);
}

export function StoredFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoredFile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function StoredFileToJSON(value?: StoredFile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

